import { useStyle, useUser, useWorkTask } from "@tm/context-distribution"
import { IFrame } from "@tm/controls"
import { useLocalization } from "@tm/localization"
import { VehicleType } from "@tm/models"
import { useActions } from "@tm/morpheus"
import { classes, decodeUniqueId, RouteComponentProps, useMessage, withRouter } from "@tm/utils"
import { percent } from "csx"
import { useSelector } from "react-redux"
import { useEffect, useRef, useState } from "react"
import { WrapperFrame } from "../_shared/wrapperFrame"
import { Actions, TemotState } from "./business"
import { LoginRequest } from "../../data"
import { buildBaseRequestParametersWithoutVehicle, compareAndSetRequestUrl } from "../../data/helpers/common"
import { getBundleParams } from "../../utils"
import { getWorktaskId } from "../../data/helpers"

type RouteProps = {
    workTaskId: string
}

type Props = RouteComponentProps<RouteProps> & {
    id: string
    loginUrl: string
    loginRequest: LoginRequest
    className?: string
}
function TemotFrame({ id, loginRequest, loginUrl, match: { params }, className }: Props) {
    const { languageId } = useLocalization()
    const workTaskId = getWorktaskId() ?? decodeUniqueId(params.workTaskId ?? "")
    const actions = useActions(Actions)
    const userContext = useUser()?.userContext
    const vehicle = useWorkTask()?.workTask?.vehicle

    const parameters = useSelector((s: TemotState) => s.parameters)

    const [loading, setLoading] = useState(true)
    const [url, setUrl] = useState("")
    const mounted = useRef(false)

    const buildRequestParameters = () => {
        const request = buildBaseRequestParametersWithoutVehicle(loginRequest, languageId, workTaskId, userContext)

        if (vehicle) {
            request.kTypeId =
                vehicle.vehicleType === VehicleType.CommercialVehicle
                    ? vehicle.tecDocTypeId - getBundleParams().commercialVehicleOffset
                    : vehicle.tecDocTypeId
            request.typeArt = vehicle.vehicleType
        }

        return request
    }

    const handleLoadingCallback = () => {
        mounted.current && setLoading(false)
    }

    useMessage((data) => {
        if (data.invalidSessionMvc) {
            compareAndSetRequestUrl(
                buildRequestParameters,
                loginUrl,
                setLoading,
                setUrl,
                actions.updateParameters,
                parameters,
                url,
                data.invalidSessionMvc
            )
        }
    })

    useEffect(() => {
        mounted.current = true

        return () => {
            mounted.current = false
        }
    }, [])

    useEffect(() => {
        if (workTaskId && userContext?.id && vehicle) {
            compareAndSetRequestUrl(buildRequestParameters, loginUrl, setLoading, setUrl, actions.updateParameters, parameters, url)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vehicle?.id, userContext?.id, workTaskId, languageId])

    return (
        <WrapperFrame loading={loading}>
            {url && (
                <IFrame
                    url={url}
                    className={classes(style.wrapper, className, loading ? style.hide : "")}
                    contextDependent
                    id={`iframe_${id}`}
                    onLoad={handleLoadingCallback}
                    refreshOnUrlChanged
                />
            )}
        </WrapperFrame>
    )
}

const style = useStyle({
    hide: {
        display: "none",
    },
    wrapper: {
        flex: 1,
        height: percent(100),
        width: percent(100),
    },
})(TemotFrame)

export default withRouter(TemotFrame)
